import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

export class StepperItem {
    constructor() {
        this.imageClass = null;
    }

    id: string;
    number: number;
    name: string;
    isActive: boolean;
    isSuccess: boolean;
    isError: boolean;
    imageClass: string = null;
    checkSuccess: () => boolean;
}

@Component({
    selector: 'app-stepper',
    templateUrl: './app-stepper.component.html',
    styleUrls: ['./app-stepper.component.scss']
})
export class AppStepperComponent {

    @Input() currentStepNumber: number;
    @Input() steps: StepperItem[] = [];

    @Output() clickStep: EventEmitter<StepperItem> = new EventEmitter<StepperItem>();

    moveToStep(item: StepperItem) {
        this.clickStep.emit(item);
    }

    getStepStyleClass(item: StepperItem): string {
        item.isActive = item.number == this.currentStepNumber;
        let className = "";

        if (item.imageClass != null && item.imageClass.trim() != '') {
            className = item.isActive ? 'step-icon-active' : 'step-icon';
            return className;
        }

        if (item.isSuccess && item.isActive) {
            className = "step-success step-active";
        }
        else if (item.isSuccess) {
            className = "step-success";
        }
        else if (item.isError && item.isActive) {
            className = "step-error step-active";
        }
        else if (item.isError) {
            className = "step-error";
        }
        else if (item.isActive) {
            className = "step-active step-not-completed-active";
        }

        return className;
    }
}